module.exports = __webpack_public_path__ + "static/media/red-star.4169ba8d.svg";